/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const paymentPromotionAPI = (jwt, payload) => {
    const wcEnv = {
        rootUri: '/mbp-canada-checkout',
    };
    const resourcePath = '/payment/promotions';
    return restClient.postFacade(wcEnv, resourcePath, jwt, payload, null, null, false).then((response) => response);
};

export default paymentPromotionAPI;
